
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

export class GenDataCenterOperationStatus {
    static readonly OPERATIONAL: GenDataCenterOperationStatus = new GenDataCenterOperationStatus('OPERATIONAL');
    static readonly UNDER_CONSTRUCTION: GenDataCenterOperationStatus = new GenDataCenterOperationStatus('UNDER_CONSTRUCTION');
    static readonly PLANNED: GenDataCenterOperationStatus = new GenDataCenterOperationStatus('PLANNED');
    static readonly LAND_HELD: GenDataCenterOperationStatus = new GenDataCenterOperationStatus('LAND_HELD');
    static readonly CANCELED: GenDataCenterOperationStatus = new GenDataCenterOperationStatus('CANCELED');

    public readonly name: string;

    private constructor(name: string) {
        this.name = name;
    }

    static forName(name: string) {
        if (name === 'OPERATIONAL') return GenDataCenterOperationStatus.OPERATIONAL;
        if (name === 'UNDER_CONSTRUCTION') return GenDataCenterOperationStatus.UNDER_CONSTRUCTION;
        if (name === 'PLANNED') return GenDataCenterOperationStatus.PLANNED;
        if (name === 'LAND_HELD') return GenDataCenterOperationStatus.LAND_HELD;
        if (name === 'CANCELED') return GenDataCenterOperationStatus.CANCELED;
        throw new Error('Unexpected value for GenDataCenterOperationStatus:' + name);
    }

    static values(): GenDataCenterOperationStatus[] {
        return [
            GenDataCenterOperationStatus.OPERATIONAL,
            GenDataCenterOperationStatus.UNDER_CONSTRUCTION,
            GenDataCenterOperationStatus.PLANNED,
            GenDataCenterOperationStatus.LAND_HELD,
            GenDataCenterOperationStatus.CANCELED,
        ];
    }

    toJSON(): string {
        return this.name;
    }

    toString(): string {
        return this.name;
    }
}

